module.exports = __webpack_public_path__ + "static/media/card_action.88dc61ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/Conviot/Develope/img/card_action.png
// module id = 195
// module chunks = 0